var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import styled, { keyframes, css } from 'styled-components';
import { paddingsMarginsTheme } from '../../Boost/ThemeManagement/themeObjs';
const Skeleton = (_a) => {
    var { display = 'flex', height = '1rem', width = 'auto', repetition = 1, direction = 'v', margin = '', repetitionMargin = '0.4rem', padding = '' } = _a, props = __rest(_a, ["display", "height", "width", "repetition", "direction", "margin", "repetitionMargin", "padding"]);
    return (_jsx(SkeletonContainer, Object.assign({ direction: direction, height: height, width: width, margin: margin, padding: padding, display: display, repetition: repetition }, { children: [...Array(repetition)].map((_, i) => (_jsx(SkeletonStyle, Object.assign({ height: height, repetition: repetition, direction: direction, repetitionMargin: repetitionMargin }, props), i))) })));
};
export default Skeleton;
const verticalMargin = `${paddingsMarginsTheme.themeMenuMarginSingle} 0rem`;
const horizontailMargin = `0rem ${paddingsMarginsTheme.themeMenuMarginSingle}`;
const completeMargin = paddingsMarginsTheme.themeMenuMargin;
export const getPaddingMargin = (size) => {
    switch (size) {
        case 'v':
            return verticalMargin;
        case 'h':
            return horizontailMargin;
        case 'vh':
            return completeMargin;
        case '':
            return '0rem';
        default:
            return size;
    }
};
export const SkeletonContainer = styled.div `
  display: ${(props) => props.display};
  ${(props) => props.display === 'flex' &&
    css `
      flex-direction: ${(props) => props.direction === 'v' ? 'column' : 'row'};
    `}
  width: ${(props) => props.theme.utils.getSize(props.width, true)};
  height: ${(props) => props.repetition > 1 ? 'auto' : props.theme.utils.getSize(props.height, true)};
  margin: ${(props) => getPaddingMargin(props.margin)};
  padding: ${(props) => getPaddingMargin(props.padding)};
`;
const load = keyframes `
    from {
        left: -150px;
    }
    to   {
        left: 100%;
    }
`;
const SkeletonStyle = styled.div `
  box-sizing: border-box;
  margin: ${(props) => props.repetition > 1 ? getPaddingMargin(props.repetitionMargin) : '0rem'};
  height: ${(props) => props.repetition > 1 ? props.theme.utils.getSize(props.height, true) : '100%'};
  width: ${props => props.direction === 'h' ? 100 / props.repetition + '%' : '100%'};
  border-radius: ${props => props.theme.borders.borderRadius};
  position: relative;
  overflow: hidden;
  background-color: ${props => props.theme.utils.getColorLight('grey')};
  &::before {
    content: "";
    display: block;
    position: absolute;
    left: -150px;
    top: 0;
    height: ${(props) => props.repetition > 1 ? props.theme.utils.getSize(props.height, true) : '100%'};
    width: 150px;
    background: linear-gradient(
      to right,
      transparent 0%,
      ${props => props.theme.colors.greyColor} 50%,
      transparent 100%
    );
    animation: ${load} 1s cubic-bezier(0.4, 0, 0.2, 1) infinite;
  }
`;
